module.exports = __webpack_public_path__ + "b4b96c2e029c58240faf043f9f57daae.jpg";